const Redux = require('redux');
const Reducers = require('./reducers');
const Middleware = require('./middleware');
const Enhancers = require('./enhancers');

module.exports = ({ initialState = {}, history }) => {

    // Store Instantiation and HMR Setup

    const store = Redux.createStore(
        Reducers.makeRoot({ history }),
        initialState,
        Redux.compose(
            Redux.applyMiddleware(...Middleware),
            ...Enhancers
        )
    );

    store.asyncReducers = {};

    if (module.hot) {
        module.hot.accept('./reducers', () => {

            const nextReducer = require('./reducers').makeRoot({
                history,
                asyncReducers: store.asyncReducers
            });

            store.replaceReducer(nextReducer);
        });
    }

    return store;
};
